var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover_svg__a)",
    fillRule: "evenodd",
    d: "M11.75 3.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2 11.75C2 6.365 6.365 2 11.75 2s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2 17.135 2 11.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover_svg__b)",
    d: "m9.5 10.26-3.25 6.99L13.24 14c.34-.16.6-.43.76-.76l3.25-6.99-6.99 3.25c-.34.16-.6.43-.76.76Zm2.25 2.24c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__a",
    x1: 2,
    x2: 4.79,
    y1: 2,
    y2: 23.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__b",
    x1: 6.25,
    x2: 7.824,
    y1: 6.25,
    y2: 18.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })))));
};
export default SvgDiscover;